import { render, staticRenderFns } from "./SalesFarmerPopup.vue?vue&type=template&id=4f5ee152&scoped=true"
import script from "./SalesFarmerPopup.vue?vue&type=script&lang=js"
export * from "./SalesFarmerPopup.vue?vue&type=script&lang=js"
import style0 from "./SalesFarmerPopup.vue?vue&type=style&index=0&id=4f5ee152&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5ee152",
  null
  
)

export default component.exports